/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import { CoreMenuService } from './services/core-menu.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[xbaht-core-menu]',
  templateUrl: './core-menu.component.html',
  styleUrl: './core-menu.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CoreMenuComponent implements OnInit {
  @Input()
  public layout = 'vertical';

  @Input()
  public menu: any;

  private _unsubscribe: Subject<void>;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreMenuService: CoreMenuService
  ) {
    this._unsubscribe = new Subject<void>();
  }

  ngOnInit(): void {
    this.menu = this.menu || this._coreMenuService.getCurrentMenu();

    this._coreMenuService.onMenuChanged
      .pipe(takeUntil(this._unsubscribe))
      .subscribe(() => {
        this.menu = this._coreMenuService.getCurrentMenu();

        this._changeDetectorRef.markForCheck();
      });
  }
}
